module.exports = __webpack_public_path__ + "static/img/logo-fff.87a10ef7.png";